import React from 'react';
import ErrorPage from '../login/ErrorPage';
import NotFound404 from '../login/NotFound404';

const NotFound = () => (
  <NotFound404/>
);

export default NotFound;
